<template>
	<div class="scoreBox">
		<div class="scoreBoxTitle">
			<div class="scoreBoxTitle-left">
				<img src="../../assets/tennis/icon2.png" alt="">
				<span>2023五星网球分级挑战赛年终总决赛</span>
			</div>
			<div class="scoreBoxTitle-right">
				<div class="btnBox" @click="toPage">
					<img src="../../assets/tennis/icon3.png" alt="">
					<span>设置模式</span>
				</div>
				<div class="btnBox">
					<img src="../../assets/tennis/icon4.png" alt="">
					<span>退出登录</span>
				</div>
			</div>
		</div>
		<div class="operation">
			<div class="operation-m1">
				<img src="../../assets/tennis/icon11.png" @click="arrow(0)" alt="">
				<div class="operation-m1-text">
					当前：第<span>{{ curTimes }}</span>局
				</div>
				<img src="../../assets/tennis/icon10.png" @click="arrow(1)" alt="">
			</div>
			<!-- <div class="operation-m2">
				<van-button type="primary" @click="overGame">本局结束</van-button>
			</div> -->
			<div class="operation-m3">
				<van-button type="primary" @click="start">开始</van-button>
				<van-button type="primary" @click="overGame">结束</van-button>
			</div>
		</div>
		<div class="scoreBoxMain">
			<div class="scoreBoxMain-m1">
				<div class="countScore" v-if="resData.length != 0">{{ resData[0].score }}</div>
				<div class="xuanshou1">
					<img src="../../assets/tennis/icon5.png" alt="">
					<span v-if="resData.length != 0">选手1:{{ resData[0].name }}</span>
				</div>
				<div class="iptBox">
					<img src="../../assets/tennis/icon6.png" @click="editScore(0, 0)" alt="">
					<div class="ipt">
						<span v-if="resData.length != 0" :class="[scores[0].score == null ? 'ipt-01 color1' : 'ipt-01 color2']">{{ scores[0].score == null ? '请输入' : scores[0].score }}</span>
						<span class="ipt-02"></span>
					</div>
					<img src="../../assets/tennis/icon7.png" @click="editScore(0, 1)" alt="">
				</div>
				<div class="iconbox">
					<img v-if="resData.length != 0 && scores[0].serve == 1" src="../../assets/tennis/icon8.png" alt="">
					<img v-else @click="editServe(0)" src="../../assets/tennis/icon9.png" alt="">
				</div>
			</div>
			<div class="scoreBoxMain-m1">
				<div class="countScore" v-if="resData.length != 0">{{ resData[1].score }}</div>
				<div class="xuanshou1">
					<img src="../../assets/tennis/icon5.png"  alt="">
					<span v-if="resData.length != 0">选手2:{{ resData[1].name }}</span>
				</div>
				<div class="iptBox">
					<img src="../../assets/tennis/icon6.png" @click="editScore(1, 0)"  alt="">
					<div class="ipt">
						<span v-if="resData.length != 0" :class="[scores[1].score == null ? 'ipt-01 color1' : 'ipt-01 color2']">{{ scores[1].score == null ? '请输入' : scores[1].score }}</span>
						<span class="ipt-02"></span>
					</div>
					<img src="../../assets/tennis/icon7.png" @click="editScore(1, 1)" alt="">
				</div>
				<div class="iconbox">
					<img v-if="resData.length != 0 && scores[1].serve == 1" src="../../assets/tennis/icon8.png" alt="">
					<img v-else @click="editServe(1)" src="../../assets/tennis/icon9.png" alt="">
				</div>
			</div>
		</div>
		
		<van-popup v-model="show" :close-on-click-overlay="false">
			<van-loading size="24px" color="#ff" vertical>请稍候...</van-loading>
		</van-popup>
	</div>
</template>

<script>
export default {
	name: 'score',
	data(){
		return {
			show: false,
			isshow: true,
			
			curTimes: 1,
			countTimes: 1,
			
			resData: [],
			scores: [],
			
			start01: 0,
		}
	},
	mounted() {
		this.matchid = this.$route.query.matchid
		this.trackid = this.$route.query.trackid
		console.log(this.$route.query.groupnum, 'iiiii')
		if(this.$route.query.groupnum == undefined){
			this.groupnum = ''
			this.$toast({
				className: 'mytoast2',
				type: 'fail',
				message: '请先点击设置模式设置组别后打分!',
				duration: 4000
			});
		}else{
			this.groupnum = this.$route.query.groupnum
			this.getData();
		}
	},
	methods: {
		toPage(){
			console.log("999999")
			this.$router.push({
				name: 'tennissetting',
				query: {
					matchid: this.matchid,
					trackid: this.trackid,
					groupnum: this.groupnum,
					isset: 1,
				}
			})
		},
		arrow(n){
			if(n == 0){
				//左箭头
				if(this.curTimes == 1){
					this.$toast({
						className: 'mytoast2',
						type: 'fail',
						message: '当前已是第一局!',
						duration: 4000
					});
					return
				}
				this.curTimes = this.curTimes - 1
				this.getData()
			}else{
				//右箭头
				this.curTimes = this.curTimes + 1
				this.getData()
			}
		},
		editScore(p, e){
			// 15
			if(p == 0){
				//左边一个人
				if(e == 0){
					// 减
					if(this.scores[0].score == 0){
						this.$toast({
							className: 'mytoast2',
							type: 'fail',
							message: '最小值为0分!',
							duration: 4000
						});
						return
					}
					
					if(this.curTimes != 7){
						// 非第七局
						if(Number(this.scores[0].score) == 15){
							this.$set(this.scores[0], 'score', Number(this.scores[0].score) - 15)
						}else if(Number(this.scores[0].score) == 30){
							this.$set(this.scores[0], 'score', Number(this.scores[0].score) - 15)
						}else if(Number(this.scores[0].score) == 40){
							this.$set(this.scores[0], 'score', Number(this.scores[0].score) - 10)
						}else{
							this.$set(this.scores[0], 'score', Number(this.scores[0].score) - 5)
						}
					}else{
						// 第七局
						this.$set(this.scores[0], 'score', Number(this.scores[0].score) - 1)
					}
					
					
					
					this.edit(0)
				}else{
					// 加
					if(this.scores[0].score == 45){
						this.$toast({
							className: 'mytoast2',
							type: 'fail',
							message: '最大值为45分!',
							duration: 4000
						});
						return
					}
					if(this.curTimes != 7){
						if(Number(this.scores[0].score) == 0){
							this.$set(this.scores[0], 'score', Number(this.scores[0].score) + 15)
						}else if(Number(this.scores[0].score) == 15){
							this.$set(this.scores[0], 'score', Number(this.scores[0].score) + 15)
						}else if(Number(this.scores[0].score) == 30){
							this.$set(this.scores[0], 'score', Number(this.scores[0].score) + 10)
						}else{
							this.$set(this.scores[0], 'score', Number(this.scores[0].score) + 5)
						}
					}else{
						this.$set(this.scores[0], 'score', Number(this.scores[0].score) + 1)
					}
					
					// this.$set(this.scores[0], 'score', Number(this.scores[0].score) + 15)
					this.edit(0)
				}
			}else{
				//右边一个人
				if(e == 0){
					// 减
					if(this.scores[1].score == 0){
						this.$toast({
							className: 'mytoast2',
							type: 'fail',
							message: '最小值为0分!',
							duration: 4000
						});
						return
					}
					
					if(this.curTimes != 7){
						if(Number(this.scores[1].score) == 15){
							this.$set(this.scores[1], 'score', Number(this.scores[1].score) - 15)
						}else if(Number(this.scores[1].score) == 30){
							this.$set(this.scores[1], 'score', Number(this.scores[1].score) - 15)
						}else if(Number(this.scores[1].score) == 40){
							this.$set(this.scores[1], 'score', Number(this.scores[1].score) - 10)
						}else{
							this.$set(this.scores[1], 'score', Number(this.scores[1].score) - 5)
						}
					}else{
						this.$set(this.scores[1], 'score', Number(this.scores[1].score) - 1)
					}
					
					
					// this.$set(this.scores[1], 'score', Number(this.scores[1].score) - 15)
					this.edit(0)
				}else{
					// 加
					if(this.scores[1].score == 45){
						this.$toast({
							className: 'mytoast2',
							type: 'fail',
							message: '最最大值值为45分!',
							duration: 4000
						});
						return
					}
					
					if(this.curTimes != 7){
						if(Number(this.scores[1].score) == 0){
							this.$set(this.scores[1], 'score', Number(this.scores[1].score) + 15)
						}else if(Number(this.scores[1].score) == 15){
							this.$set(this.scores[1], 'score', Number(this.scores[1].score) + 15)
						}else if(Number(this.scores[1].score) == 30){
							this.$set(this.scores[1], 'score', Number(this.scores[1].score) + 10)
						}else{
							this.$set(this.scores[1], 'score', Number(this.scores[1].score) + 5)
						}
					}else{
						this.$set(this.scores[1], 'score', Number(this.scores[1].score) + 1)
					}
					
					
					// this.$set(this.scores[1], 'score', Number(this.scores[1].score) + 15)
					this.edit(0)
				}
			}
		},
		overGame(){
			this.edit(1)
		},
		start(){
			this.start01 = 1
			this.edit(0)
		},
		editServe(p){
			if(p == 0){
				this.$set(this.scores[0], 'serve', 1)
				this.$set(this.scores[1], 'serve', 0)
			}else{
				this.$set(this.scores[0], 'serve', 0)
				this.$set(this.scores[1], 'serve', 1)
			}
			this.edit(0)
			
		},
		edit(finish){
			var data = {
				matchid: this.matchid,
				trackid: this.trackid,
				groupnum: this.groupnum,
				times: this.curTimes,
				finish: finish,
				scores: JSON.stringify(this.scores)
			}
			this.$api.tennis
				.editscore(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						if(finish == 1){
							this.$toast({
								className: 'mytoast2',
								type: 'success',
								message: '本局已结束!',
								duration: 2000
							});
							this.getData()
						}
						if(this.start01 == 1){
							this.start01 = 0
							this.$toast({
								className: 'mytoast2',
								type: 'success',
								message: '本局开始准备!',
								duration: 2000
							});
							this.getData()
						}
					}
			})
		},
		getData(){
			let _this = this
			this.matchid = this.$route.query.matchid
			this.trackid = this.$route.query.trackid
			this.groupnum = this.$route.query.groupnum
			var data = {
				matchid: this.matchid,
				trackid: this.trackid,
				groupnum: this.groupnum
			}
			
			this.$api.tennis
				.getDataBoard(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						// _this.$set(res.data[0], 'serve', 1)
						// _this.$set(res.data[1], 'serve', 0)
						_this.scores = [{
							"number": res.data[0].number,
							"score": 0,
							"serve":1,
						},{
							"number": res.data[1].number,
							"score":0,
							"serve":0,
						}]
						if(res.data[0].scores.length == 0){
							// _this.$set(res.data[0], 'isdata', null)
							_this.$set(_this.scores[0], 'score', 0)
							_this.$set(_this.scores[0], 'serve', 0)
						}else{
							if(this.curTimes > res.data[0].scores.length){
								_this.$set(_this.scores[0], 'score', 0)
								_this.$set(_this.scores[0], 'serve', 0)
							}else{
								res.data[0].scores.forEach((item, index) => {
									if(Number(_this.curTimes) === Number(item.times)){
										// console.log("mmmm", _this.curTimes, item.times)
										// _this.$set(res.data[0], 'isdata', res.data[0].scores[index].score)
										_this.$set(_this.scores[0], 'score', item.score)
										// _this.scores[0].score = item.score
										// console.log("uuuuu",item.score, _this.scores[0])
										_this.$set(_this.scores[0], 'serve', item.serve)
									}
									// }else{
									// 	console.log("uuuuummm",item.score, _this.scores[0])
									// 	// _this.$set(res.data[0], 'isdata', null)
									// 	_this.$set(_this.scores[0], 'score', 0)
									// 	_this.$set(_this.scores[0], 'serve', 0)
									// }
									
								})
							}
							

						}
						
						if(res.data[1].scores.length == 0){
							// _this.$set(res.data[1], 'isdata', null)
							_this.$set(_this.scores[1], 'score', 0)
							_this.$set(_this.scores[1], 'serve', 0)
						}else{
							if(this.curTimes > res.data[1].scores.length){
								_this.$set(_this.scores[1], 'score', 0)
								_this.$set(_this.scores[1], 'serve', 0)
							}else{
								res.data[1].scores.forEach((item, index) => {
									if(Number(_this.curTimes) === Number(item.times)){
										// console.log("mmmm", _this.curTimes, item.times)
										// _this.$set(res.data[0], 'isdata', res.data[0].scores[index].score)
										_this.$set(_this.scores[1], 'score', item.score)
										// _this.scores[0].score = item.score
										// console.log("uuuuu",item.score, _this.scores[1])
										_this.$set(_this.scores[1], 'serve', item.serve)
									}
									// }else{
									// 	console.log("uuuuummm",item.score, _this.scores[0])
									// 	// _this.$set(res.data[0], 'isdata', null)
									// 	_this.$set(_this.scores[0], 'score', 0)
									// 	_this.$set(_this.scores[0], 'serve', 0)
									// }
									
								})
							}
						
						}
						
						// _this.$set(res.data[0], 'serve', 1)
						// _this.$set(res.data[1], 'serve', 0)
						_this.resData = res.data
						// console.log("this.redata", _this.resData)
						// console.log("this.redata222", _this.scores)
					}
				
			});
		}
	}
}
</script>

<style lang="less" scoped>
@import './referee.less';
</style>
